<template lang="pug">
  .status(v-if="status", :style="style")
    span {{status.label}}
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'StatusLabel',
  props: {
    status: Object
  },
  computed: {
    style () {
      let style = {}
      //if (this.status.bgColor) {
      //  style.backgroundColor = this.status.bgColor
      //}
      if (this.status.bgColor) {
        style.color = this.status.bgColor
      }
      return style
    }
  }
}
</script>

<style lang="stylus" scoped>
  .status
    //border-radius 4px
    display inline-block
    font-size $text-size-smaller
    font-weight 500
    //padding 2px 4px
    text-transform uppercase
</style>
